import { createContext, useContext, useEffect } from "react";

interface HeaderContextType {
  customBackHandler: (() => void) | undefined;
  setCustomBackHandler: (handler: (() => void) | undefined) => void;
  hideBackButton?: boolean;
  setHideBackButton: (hide?: boolean) => void;
}

export const HeaderContext = createContext<HeaderContextType | undefined>(
  undefined
);

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error("useHeaderContext must be used within a HeaderProvider");
  }
  return context;
};

export const useHeaderBackContext = (data: {
  handleBack?: (() => void) | undefined;
  hideBackButton?: boolean;
}) => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error("useHeaderContext must be used within a HeaderProvider");
  }
  const { handleBack, hideBackButton } = data;

  useEffect(() => {
    context.setCustomBackHandler(() => handleBack);
  }, [context, handleBack]);

  useEffect(() => {
    context.setHideBackButton(!!hideBackButton);
  }, [context, hideBackButton]);
};
